export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const InterceptorSkipOemDealerIdHeader = 'X-Skip-Oem-Dealer-Interceptor';
export const InterceptorSkipDealerIdHeader = 'X-Skip-Dealer-Interceptor';

